import { BrandedFooter } from '@components/branding';
import { PinCodeForm } from '@screens/review-section3/pincode-authorisation/pin-code-form';
import {
    Paragraph,
    PinCodeAuthorisationContainer
} from '@screens/review-section3/pincode-authorisation/styles';
import {
    CenterContainer,
    Content,
    Header
} from '@screens/review-section3/styles';
import { createTranslationService } from '@services/factories';
import { StringFormatService } from '@services/StringFormatService';
import { IPinCodeStore } from '@stores/authorisation/pin-code-store';
import { ScrollContainer } from '@styles/container-styles';
import {
    cacheTranslationLists,
    cacheTranslations
} from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {
    pinCodeStore: IPinCodeStore;
    candidateName: string;
    onResendPin: () => void;
    onPinSuccess: () => void;
    onPinFailure: () => void;
}

enum PinCodeAuthorisationTranslation {
    /**
     * @deprecated - Use introductionLines instead
     */
    greeting = 'greeting',
    /**
     * @deprecated - Use introductionLines instead
     */
    confirmIdentityDescriptionTemplate = 'confirmIdentityDescriptionTemplate',
    resendCodeButton = 'resendCodeButton',
    invalidLink = 'invalidLink',
    sendingPinCode = 'sendingPinCode'
}

enum TranslationObjects {
    introductionLines = 'introductionLines'
}

@observer
class PinCodeAuthorisationPage extends React.Component<Props> {
    static readonly translationContext: string = 'pinCodeAuthorisation';

    readonly translations = cacheTranslations(
        createTranslationService(),
        PinCodeAuthorisationTranslation,
        PinCodeAuthorisationPage.translationContext
    );

    /**
     * Text lines to present above the pin code form.
     * As it cannot be known from code where the candidate's name will be inserted,
     * all lines will be treated as templates with the following data available:
     * 0. The candidate's full name
     */
    readonly translationLists = cacheTranslationLists(
        createTranslationService(),
        TranslationObjects,
        PinCodeAuthorisationPage.translationContext
    );

    render() {
        const { pinCodeStore } = this.props;

        if (!pinCodeStore.sentInitialPinRequest) {
            return null;
        }

        return (
            <ScrollContainer>
                <CenterContainer fillAvailable={true}>
                    {pinCodeStore.hasInvalidId ? this.renderWithInvalidId() : this.renderWithValidId()}
                </CenterContainer>
                <BrandedFooter/>
            </ScrollContainer>
        );
    }

    renderWithInvalidId() {
        return (
            <PinCodeAuthorisationContainer>
                <Header>
                    <span>{this.translations.invalidLink}</span>
                </Header>
            </PinCodeAuthorisationContainer>
        );
    }

    renderWithValidId() {
        const {
            pinCodeStore,
            candidateName,
            onPinFailure,
            onPinSuccess,
            onResendPin
        } = this.props;

        return (
            <PinCodeAuthorisationContainer>
                <Header>
                    {
                        this.translationLists.introductionLines.map((line, index) => (
                            <Paragraph key={`greeting-${index}`}>
                                {StringFormatService.format(line, [candidateName])}
                            </Paragraph>
                        ))
                    }
                </Header>
                <Content>
                    <PinCodeForm
                        pinCodeStore={pinCodeStore}
                        onSendPinCode={onResendPin}
                        onAuthenticationSuccess={onPinSuccess}
                        onAuthenticationFailure={onPinFailure}
                    />
                </Content>
            </PinCodeAuthorisationContainer>
        );
    }
}

export default PinCodeAuthorisationPage;



// WEBPACK FOOTER //
// ./src/screens/review-section3/pincode-authorisation/page.tsx